import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { notesAPI } from '../services/api';

export interface Notes {
  content: string;
  updatedAt: string;
}

export const useNotes = () => {
  const queryClient = useQueryClient();

  // Get user's notes
  const {
    data: notes,
    isLoading,
    error,
    refetch
  } = useQuery<Notes>({
    queryKey: ['notes'],
    queryFn: notesAPI.get,
  });

  // Update notes mutation
  const updateNotes = useMutation({
    mutationFn: (data: { content: string }) => 
      notesAPI.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notes'] });
    },
  });

  return {
    notes,
    isLoading,
    error,
    refetch,
    updateNotes: updateNotes.mutate,
    isUpdating: updateNotes.isPending,
  };
};

